import { Time } from "@angular/common";

export class UserAgreementModel {
  systemAccessNotice: boolean;
  privacyActNotification: boolean;
  DateTime: string;
}
